export const fetchAddressUrl = (postalCode: number): string => {
  return `https://viacep.com.br/ws/${postalCode}/json/`;
}